"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WebsocketConfig {
    constructor(url, useTls, requireValidSsl) {
        this.url = url;
        this.useTls = useTls !== undefined ? useTls : true;
        this.requireValidSsl =
            requireValidSsl !== undefined ? requireValidSsl : true;
    }
}
exports.WebsocketConfig = WebsocketConfig;
